import React from "react";

import { AiOutlineTwitter } from "react-icons/ai";
import { FaDiscord, FaTiktok } from "react-icons/fa";
import Swal from "sweetalert2";


export default function Footer() {

    const corPrincipal = '#dc494c';

    const mensagem = (a = null) => {
        if (a !== null) {
            a.preventDefault();
        }
        Swal.fire({ title: 'Quase lá !', html: '<p>Relaxa, você não fez nada de errado.</p><br/><p>Acontece que o site ainda não está pronto. Estamos desenvolvendo ele dia após dia. Oque você vê aqui é apenas uma demostração visual de como a página principal do site ficará. Logo botões e as demais ações estão desabilitadas.</p>', icon: 'info' }).then(() => {
            Swal.fire({ title: 'Fique por dentro :)', html: "<p>Em nossas redes sociais você saberá certinho como está sendo todo o processo de desenvolvimento do seu Bar preferido (Taldo's Bar) com videos e etc.</p><br /><p>Eai, vem ficar pertinho da gente !!! </p><a style='color:blue;text-decoration:underline' href='" + window.location.origin + "'>Clique aqui</a>", icon: 'info' })
        })
    }

    return (
        <footer style={{ color: corPrincipal }}>
            <div className="flex container">
                <div className="part-1-footer">
                    <p>Tem alguma sugestão ?</p>
                    <p>Reclamação ou aviso de Bug ?</p>
                    <p>Mande um email para nós utilizando o campo abaixo</p>
                    <p>Sua opinião sempre será bem vinda!!</p>
                    <form method="post">
                        <input type='text' />
                        <input type='text' />
                        <input type='text' />
                        <input onClick={(a) => mensagem(a)} style={{ backgroundColor: corPrincipal }} type='submit' value="Enviar" />
                    </form>
                </div>
                <div className="part-2-footer">
                    <p>Nos ajude a continuar mantendo o site</p>
                    <a target="_blank" href="https://apoia.se/taldobars" style={{ backgroundColor: corPrincipal }} className="button-cartase">Apoia-se</a>
                </div>
                <div className="part-3-footer">
                    <p>Veja as novidades futuras em nossas redes sociais</p>
                    <div className="flex">
                        <div className="button-social"><a href="https://discord.gg/acMgWMDeBC" target="_blank"><FaDiscord /></a></div>
                        <div className="button-social"><a href="https://twitter.com/taldosbars_ofc" target="_blank"><AiOutlineTwitter /></a></div>
                        <div className="button-social"><a href="https://www.tiktok.com/@taldosbars_official" target="_blank"><FaTiktok /></a></div>
                    </div>
                </div>
            </div>
            <div className="footer-footer">
                <a style={{ color: corPrincipal }} onClick={(a) => mensagem(a)} href="">Nossos Termos e Condições ! / Que Informações Coletamos ?</a>
            </div>
        </footer>
    )

}